/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Skillgroupname2Inputs */

const en_entity_skillgroupname2 = /** @type {(inputs: Entity_Skillgroupname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Group Name`)
};

const de_entity_skillgroupname2 = /** @type {(inputs: Entity_Skillgroupname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Skill Group Name" |
*
* @param {Entity_Skillgroupname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_skillgroupname2 = /** @type {((inputs?: Entity_Skillgroupname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Skillgroupname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skillgroupname2(inputs)
	return de_entity_skillgroupname2(inputs)
});
export { entity_skillgroupname2 as "entity_skillGroupName" }